var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var linkTypeMap = function (typeMap) {
    var indexToName = Object.assign.apply(Object, __spreadArray([{}], Object.keys(typeMap.types).map(function (k, i) {
        var _a;
        return (_a = {}, _a[i] = k, _a);
    }), false));
    var intermediaryTypeMap = Object.assign.apply(Object, __spreadArray([{}], Object.keys(typeMap.types || {}).map(function (k) {
        var _a;
        var type = typeMap.types[k];
        var fields = type || {};
        return _a = {},
            _a[k] = {
                name: k,
                // type scalar properties
                scalar: Object.keys(fields).filter(function (f) {
                    var _a;
                    var type = (fields[f] || [])[0];
                    var isScalar = type && typeMap.scalars.includes(type);
                    if (!isScalar) {
                        return false;
                    }
                    var args = (_a = fields[f]) === null || _a === void 0 ? void 0 : _a[1];
                    var argTypes = Object.values(args || {})
                        .map(function (x) { return x === null || x === void 0 ? void 0 : x[1]; })
                        .filter(Boolean);
                    var hasRequiredArgs = argTypes.some(function (str) { return str && str.endsWith('!'); });
                    if (hasRequiredArgs) {
                        return false;
                    }
                    return true;
                }),
                // fields with corresponding `type` and `args`
                fields: Object.assign.apply(Object, __spreadArray([{}], Object.keys(fields).map(function (f) {
                    var _a;
                    var _b = fields[f] || [], typeIndex = _b[0], args = _b[1];
                    if (typeIndex == null) {
                        return {};
                    }
                    return _a = {},
                        _a[f] = {
                            // replace index with type name
                            type: indexToName[typeIndex],
                            args: Object.assign.apply(Object, __spreadArray([{}], Object.keys(args || {}).map(function (k) {
                                var _a;
                                // if argTypeString == argTypeName, argTypeString is missing, need to readd it
                                if (!args || !args[k]) {
                                    return;
                                }
                                var _b = args[k], argTypeName = _b[0], argTypeString = _b[1];
                                return _a = {},
                                    _a[k] = [
                                        indexToName[argTypeName],
                                        argTypeString ||
                                            indexToName[argTypeName],
                                    ],
                                    _a;
                            }), false)),
                        },
                        _a;
                }), false)),
            },
            _a;
    }), false));
    var res = resolveConcreteTypes(intermediaryTypeMap);
    return res;
};
// replace typename with concrete type
export var resolveConcreteTypes = function (linkedTypeMap) {
    Object.keys(linkedTypeMap).forEach(function (typeNameFromKey) {
        var type = linkedTypeMap[typeNameFromKey];
        // type.name = typeNameFromKey
        if (!type.fields) {
            return;
        }
        var fields = type.fields;
        Object.keys(fields).forEach(function (f) {
            var field = fields[f];
            if (field.args) {
                var args_1 = field.args;
                Object.keys(args_1).forEach(function (key) {
                    var arg = args_1[key];
                    if (arg) {
                        var typeName_1 = arg[0];
                        if (typeof typeName_1 === 'string') {
                            if (!linkedTypeMap[typeName_1]) {
                                linkedTypeMap[typeName_1] = { name: typeName_1 };
                            }
                            arg[0] = linkedTypeMap[typeName_1];
                        }
                    }
                });
            }
            var typeName = field.type;
            if (typeof typeName === 'string') {
                if (!linkedTypeMap[typeName]) {
                    linkedTypeMap[typeName] = { name: typeName };
                }
                field.type = linkedTypeMap[typeName];
            }
        });
    });
    return linkedTypeMap;
};
